import { render, staticRenderFns } from "./DeviceWarnings.vue?vue&type=template&id=74f99919&scoped=true"
import script from "./DeviceWarnings.vue?vue&type=script&lang=js"
export * from "./DeviceWarnings.vue?vue&type=script&lang=js"
import style0 from "./DeviceWarnings.vue?vue&type=style&index=0&id=74f99919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f99919",
  null
  
)

export default component.exports